import styled from 'styled-components';

// Shared by the rich text and Markdown editors (StudioText, MarkdownText),
// for the metric picker a '{' typed opens

// After a '{' typed, while the metric picker it opened is: what to do, in
// the line as if typed, faintly (as a placeholder is)
export const TypingHint = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  margin-left: 2px;
  padding: 0 4px;
  border-radius: 4px;
  background-color: var(--color-bg-soft);
  color: var(--color-text-tertiary);
  font-size: 14px;
  white-space: nowrap;
  pointer-events: none;
`;

// Where a '{' was typed, as tall as its line, for the metric picker it
// opens to open from: under the line, or above it where there's no room
export const PickerAnchor = styled.div`
  position: absolute;
  width: 1px;
`;
